const EmailJail = () => {
    return (
        <>
            <h4>Verify your email, or else...</h4>
        </>
    )
}

export default EmailJail
